
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
a,
ul,
li{
  color:inherit;
  text-decoration:inherit;
  list-style-type:none;
  margin-left:0;
  padding-left:0;
  margin-block-start:0;
  margin-block-end:0;
  margin-inline-start:0;
  margin-inline-end:0;
  padding-inline-start:0;
}
:host {
  display:block;
}
[cloned-slot-name='subnav-label'] {
  display:none;
}
.has-navigation{
  --navigation-height:69px;
}
.has-navigation--start nav::before, .has-navigation--last nav::after {
  display:none !important;
}
@media (min-width: 1024px) {
  .has-navigation nav {
    position:relative;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav {
    width:100%;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav {
    max-width:56rem;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav {
    overflow-x:clip;
  }
}
@media (min-width: 1280px) {
  .has-navigation nav {
    max-width:72rem;
  }
}
@media (min-width: 1360px) {
  .has-navigation nav {
    max-width:1280px;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    position:absolute;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    top:0px;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    z-index:10;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    display:block;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    width:3rem;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    --tw-gradient-from:var(--neutral-transparent);
    --tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0));
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    --tw-gradient-to:var(--primary-blue-light-2);
  }
}
@media (min-width: 1024px){
.has-navigation nav::after,
    .has-navigation nav::before{
        content:'';
        height:var(--navigation-height)
    }
      }
@media (min-width: 1024px) {
  .has-navigation nav::after {
    right:0px;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::after {
    background-image:linear-gradient(to right, var(--tw-gradient-stops));
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::before {
    left:0px;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav::before {
    background-image:linear-gradient(to left, var(--tw-gradient-stops));
  }
}
@media (min-width: 1024px) {
  .has-navigation nav > ul {
    width:max-content;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav > ul {
    transition-property:transform;
    transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration:150ms;
  }
}
@media (min-width: 1024px) {
  .has-navigation nav > ul {
    transition-delay:75ms;
  }
}
.has-navigation .button {
  display:none;
}
@media (min-width: 1024px) {
  .has-navigation .button {
    display:inline-flex;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    cursor:pointer;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    align-items:center;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    justify-content:center;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    gap:0.5rem;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    border-width:0px;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    border-bottom-width:4px;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    border-color:var(--neutral-transparent);
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    background-color:var(--primary-blue-light-2);
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    padding-left:1rem;
    padding-right:1rem;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    font-weight:var(--fw-semibold);
  }
}
@media (min-width: 1024px) {
  .has-navigation .button {
    color:var(--neutral-white);
  }
}
@media (min-width: 1024px){
.has-navigation .button{
      height:var(--navigation-height)
  }
    }
@media (min-width: 1024px) {
  .has-navigation .button[disabled] {
    opacity:0.1;
  }
}
@media (min-width: 1024px) {
  .has-navigation .button[disabled] {
    transition-property:opacity;
    transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration:150ms;
  }
}
@media (min-width: 1024px) {
  .has-navigation [cloned-slot-name='navigation'] {
    margin-left:auto;
    margin-right:auto;
  }
}
@media (min-width: 1024px) {
  .has-navigation [cloned-slot-name='navigation'] {
    display:flex;
  }
}
@media (min-width: 1024px) {
  .navigation {
    display:flex;
  }
  .navigation {
    flex-direction:column;
  }
  .navigation {
    justify-content:center;
  }
}
.navigation nav > ul {
  position:relative;
}
.navigation nav > ul {
  display:block;
}
.navigation nav > ul {
  text-align:left;
}
.navigation nav > ul {
  font-weight:var(--fw-semibold);
}
@media (min-width: 1024px) {
  .navigation nav > ul {
    display:flex;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul {
    justify-content:space-between;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul {
    gap:1.5rem;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul {
    text-align:center;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}
@media (min-width: 1280px) {
  .navigation nav > ul {
    justify-content:center;
  }
}
.navigation nav > ul{
    line-height:1.2;
  }
.navigation nav > ul > li {
  border-width:0px;
}
.navigation nav > ul > li {
  border-bottom-width:1px;
}
.navigation nav > ul > li {
  border-style:solid;
}
.navigation nav > ul > li:last-child {
  border-style:none;
}
.navigation nav > ul > li.has-children {
  display:flex;
}
.navigation nav > ul > li.has-children {
  flex-wrap:wrap;
}
.navigation nav > ul > li.has-children {
  justify-content:space-between;
}
@media (min-width: 1024px) {
  .navigation nav > ul > li.has-children {
    flex-wrap:nowrap;
  }
}
.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  box-sizing:border-box;
}
.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  display:flex;
}
.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  height:100%;
}
.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  align-items:center;
}
.navigation nav > ul > li[is-dropdown-open] ghs-icon{
    transform:rotate(180deg);
  }
.navigation nav > ul > li[is-dropdown-open] > ul {
  display:block;
}
@media (min-width: 1024px){
    .navigation nav > ul > li:hover > ul, .navigation nav > ul > li:active > ul {
    display:block;
  }
  }
.navigation nav > ul > li > ul {
  display:none;
}
.navigation nav > ul > li > ul {
  width:100%;
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    position:absolute;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    z-index:50;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    margin-top:0px;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    width:auto;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    background-color:var(--neutral-white);
  }
}
.navigation nav > ul > li > ul > li {
  padding-left:0.5rem;
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    padding-left:1.25rem;
    padding-right:1.25rem;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    padding-top:0px;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    padding-bottom:0px;
  }
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    text-align:left;
  }
}
.navigation nav > ul > li > ul > li:first-child {
  display:block;
}
.navigation nav > ul > li > ul > li:last-child {
  padding-bottom:0.5rem;
}
@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li:last-child {
    padding-bottom:1.25rem;
  }
}
.navigation button.dropdown-trigger {
  position:relative;
}
.navigation button.dropdown-trigger {
  display:inline-flex;
}
.navigation button.dropdown-trigger {
  min-height:44px;
}
.navigation button.dropdown-trigger {
  min-width:22px;
}
.navigation button.dropdown-trigger {
  cursor:pointer;
}
.navigation button.dropdown-trigger {
  align-items:center;
}
.navigation button.dropdown-trigger {
  justify-content:flex-end;
}
.navigation button.dropdown-trigger {
  border-width:0px;
}
.navigation button.dropdown-trigger {
  background-color:var(--neutral-transparent);
}
.navigation button.dropdown-trigger {
  padding-left:0px;
  padding-right:0px;
}
.navigation button.dropdown-trigger {
  text-align:left;
}
.navigation button.dropdown-trigger {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}
.navigation button.dropdown-trigger {
  font-weight:var(--fw-semibold);
}
@media (min-width: 1024px) {
  .navigation button.dropdown-trigger {
    justify-content:flex-start;
  }
}
@media (min-width: 1024px) {
  .navigation button.dropdown-trigger {
    text-align:center;
  }
}
@media (min-width: 1024px) {
  .navigation button.dropdown-trigger {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}
.navigation button.dropdown-trigger ghs-icon {
  display:flex;
}
.navigation button.dropdown-trigger ghs-icon {
  height:1.25rem;
}
.navigation button.dropdown-trigger ghs-icon {
  width:1.25rem;
}
.navigation button.dropdown-trigger ghs-icon {
  align-items:center;
}
.navigation button.dropdown-trigger ghs-icon {
  justify-content:center;
}
@media (min-width: 1024px) {
  .navigation button.dropdown-trigger ghs-icon {
    margin-left:0.5rem;
  }
}
@media (min-width: 1024px) {
  .navigation button.dropdown-trigger ghs-icon {
    height:1rem;
  }
}
@media (min-width: 1024px) {
  .navigation button.dropdown-trigger ghs-icon {
    width:0.75rem;
  }
}
.navigation.secondary-menu a {
  pointer-events:auto;
}
.navigation.secondary-menu a {
  cursor:pointer;
}
.navigation.secondary-menu a {
  padding-left:0.5rem;
  padding-right:0.5rem;
}
.navigation.secondary-menu a {
  text-transform:capitalize;
}
.navigation.secondary-menu a.is-active:after {
  pointer-events:auto;
}
.navigation.secondary-menu a.is-active:after {
  cursor:pointer;
}
.secondary-menu nav > ul, :host([is-subnav]) nav > ul {
  gap:1.5rem;
}
:host([is-subnav]) .navigation {
  background-color:var(--neutral-white);
}
@media (min-width: 1024px){
:host([is-subnav]) .navigation{
      box-shadow:var(--brand-shadow)
  }
    }
@media (min-width: 1024px) {
  :host([is-subnav]) nav > ul {
    justify-content:center;
  }
}
:host([is-subnav]) nav > ul > li {
  flex-shrink:0;
}
:host([is-subnav]) nav > ul > li{
    text-transform:none;
  }
@media (min-width: 1024px) {
  :host([is-subnav]) nav > ul > li > ul {
    padding-top:0px;
  }
}
:host([is-top-bar-menu]) .navigation nav > ul {
  font-weight:var(--fw-normal);
}
:host([is-top-bar-menu]) .navigation nav > ul {
  display:flex;
}
:host([is-top-bar-menu]) .navigation nav > ul {
  flex-direction:column;
}
:host([is-top-bar-menu]) .navigation nav > ul {
  gap:0.5rem;
}
:host([is-top-bar-menu]) .navigation nav > ul {
  font-family:var(--ff-body);
}
@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul {
    flex-direction:row;
  }
}
@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul {
    justify-content:flex-end;
  }
}
@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul {
    gap:1.75rem;
  }
}
:host([is-top-bar-menu]) .navigation nav > ul > li {
  min-width:22px;
}
:host([is-top-bar-menu]) .navigation nav > ul > li {
  align-items:center;
}
:host([is-top-bar-menu]) .navigation nav > ul > li {
  display:none;
}
:host([is-top-bar-menu]) .navigation nav > ul > li {
  border-style:none;
}
:host([is-top-bar-menu]) .navigation nav > ul > li:not(.tel) {
  display:none;
}
@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul > li:not(.tel) {
    display:flex;
  }
}
:host([is-top-bar-menu]) .navigation nav > ul > li > a:after {
  display:none;
}
:host([is-top-bar-menu]) .navigation nav > ul > li > a, :host([is-top-bar-menu]) .navigation nav > ul > li > ghs-phone-contact {
  min-height:3.5rem;
}
:host([is-top-bar-menu]) .navigation nav > ul > li > a, :host([is-top-bar-menu]) .navigation nav > ul > li > ghs-phone-contact {
  padding-top:0px;
  padding-bottom:0px;
}
@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul > li > a, :host([is-top-bar-menu]) .navigation nav > ul > li > ghs-phone-contact {
    min-height:fit-content;
  }
}
@media (min-width: 320px){
    :host([is-top-bar-menu]) nav > ul > li {
    display:block;
  }

    :host([is-top-bar-menu]) button.dropdown-trigger {
    font-weight:var(--fw-normal);
  }
      @media (min-width: 1024px) {
    :host([is-top-bar-menu]) button.dropdown-trigger.no-link {
      padding-top:0px;
      padding-bottom:0px;
    }
  }
  }
@media (min-width: 1024px) {
  :host([site='GHS']) nav .button {
    color:var(--primary-blue);
  }
}
:host([site='GHS']) .navigation nav > ul {
  font-family:var(--ff-body);
}
:host([site='GHS']) .navigation nav > ul {
  color:var(--primary-blue-dark);
}
:host([site='GHS']) .navigation nav > ul > li {
  border-color:var(--neutral-gray-4);
}
:host([site='GHS']) .navigation nav > ul > li {
  text-transform:uppercase;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li {
    border-bottom-width:4px;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li {
    border-style:solid;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li {
    border-color:var(--outline-transparent);
  }
}
:host([site='GHS']) .navigation nav > ul > li.tel {
  display:none;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.tel {
    display:block;
  }
}
:host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
  margin-left:-1.5rem;
  margin-right:-1.5rem;
}
:host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
  border-top-width:1px;
}
:host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
  padding-left:1.5rem;
  padding-right:1.5rem;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
    margin:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
    border-top-width:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
    padding-left:0px;
    padding-right:0px;
  }
}
:host([site='GHS']) .navigation nav > ul > li:has(+ li.is-active), :host([site='GHS']) .navigation nav > ul > li:has(+ li a.is-active) {
  border-bottom-width:0px;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(+ li.is-active), :host([site='GHS']) .navigation nav > ul > li:has(+ li a.is-active) {
    border-bottom-width:4px;
  }
}
:host([site='GHS']) .navigation nav > ul > li > a, :host([site='GHS']) .navigation nav > ul > li > ghs-phone-contact {
  min-height:5rem;
}
:host([site='GHS']) .navigation nav > ul > li > a, :host([site='GHS']) .navigation nav > ul > li > ghs-phone-contact {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > a, :host([site='GHS']) .navigation nav > ul > li > ghs-phone-contact {
    min-height:0px;
  }
}
:host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
  margin-left:-1.5rem;
}
:host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
  padding-left:1rem;
}
:host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a{
      border-left:0.5rem solid var(--primary-green);
    }
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
    margin-left:0px;
    margin-right:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
    border-left-width:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
    padding-left:0px;
    padding-right:0px;
  }
}
@media (min-width: 1024px){
:host([site='GHS']) .navigation{
  }
      :host([site='GHS']) .navigation nav > ul > li > a{
        transition:all 0.2s ease-in-out;
        position:relative;
      }

        :host([site='GHS']) .navigation nav > ul > li > a:after{
          content:'';
          position:absolute;
          bottom:-5px;
          left:0;
          width:0px;
          height:4px;
          margin:5px 0 0;
          transition:all 0.2s ease-in-out;
          transition-duration:0.25s;
          opacity:0;
        }
        :host([site='GHS']) .navigation nav > ul > li:not(.has-children):hover > a:after, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a:after, :host([site='GHS']) .navigation nav > ul > li > a.is-active:after{
          width:100%;
          opacity:1;
        }
        :host([site='GHS']) .navigation nav > ul > li.has-children > a.is-active:after, :host([site='GHS']) .navigation nav > ul > li.has-children:has(a.is-active) > a:after{
          width:calc(100% + 20px);
        }
    }
:host([site='GHS']) .navigation nav > ul > li > a {
  font-family:var(--ff-display);
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > a:after {
    background-color:var(--primary-green);
  }
}
:host([site='GHS']) .navigation nav > ul > li > ul {
  visibility:hidden;
}
:host([site='GHS']) .navigation nav > ul > li > ul {
  text-transform:none;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul {
    display:block;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul {
    border-bottom-right-radius:0.75rem;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul {
    border-bottom-left-radius:0.75rem;
  }
}
@media (min-width: 1024px){
:host([site='GHS']) .navigation nav > ul > li > ul{
        box-shadow:var(--brand-shadow);
        top:calc(100% - 3px)
    }

        @media (min-width: 1024px) {
    :host([site='GHS']) .navigation nav > ul > li > ul:before {
      background-color:var(--primary-green);
    }
  }

        :host([site='GHS']) .navigation nav > ul > li > ul:before{

          content:'';
          transition:all 0.2s ease-in-out;
          transition-duration:0.25s;
          opacity:0;
          width:0;
          height:4px;
          display:block;
        }
      }
:host([site='GHS']) .navigation nav > ul > li[is-dropdown-open] > ul {
  visibility:visible;
}
:host([site='GHS']) .navigation nav > ul > li[is-dropdown-open] > ul {
  display:block;
}
:host([site='GHS']) .navigation nav > ul > li[is-dropdown-open] > ul:before{
        width:100%;
        opacity:1;
      }
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li:first-child {
    padding-top:1.25rem;
  }
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  display:block;
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  padding-top:1rem;
  padding-bottom:1rem;
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  font-weight:var(--fw-semibold);
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  color:var(--primary-blue-dark);
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a {
    padding-top:0.5rem;
    padding-bottom:0.5rem;
  }
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
  padding-left:0.5rem;
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
  color:var(--primary-blue-light-2);
}
:host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active{
        border-left:0.5rem solid var(--primary-green);
      }
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
    margin-left:-1rem;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
    padding-top:0.5rem;
    padding-bottom:0.5rem;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a:hover, :host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
    text-decoration-line:underline;
  }
}
:host([site='GHS']) .navigation button.dropdown-trigger {
  font-family:var(--ff-display);
}
:host([site='GHS']) .navigation button.dropdown-trigger {
  text-transform:uppercase;
}
:host([site='GHS']) .navigation button.dropdown-trigger {
  color:var(--primary-blue-dark);
}
:host([site='GHS']) .navigation button.dropdown-trigger:hover, :host([site='GHS']) .navigation a:hover, :host([site='GHS']) .navigation a.is-active {
  color:var(--primary-blue-light-2);
}
:host([site='GHS']) .navigation button.dropdown-trigger:hover ghs-icon, :host([site='GHS']) .navigation a:hover ghs-icon, :host([site='GHS']) .navigation a.is-active ghs-icon {
  color:var(--primary-blue-light-2);
}
:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  display:flex;
}
:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  height:100%;
}
:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  width:100%;
}
:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  align-items:center;
}
:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  justify-content:space-between;
}
:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation button.dropdown-trigger.no-link {
    justify-content:flex-start;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']) .navigation button.dropdown-trigger.no-link {
    padding-top:0px;
    padding-bottom:0px;
  }
}
:host([site='GHS']) .navigation.secondary-menu {
  background-color:var(--primary-blue-dark);
}
:host([site='GHS']) .navigation.secondary-menu a {
  color:var(--neutral-white);
}
:host([site='GHS']) .navigation.secondary-menu a:hover:after {
  background-color:var(--neutral-white);
}
:host([site='GHS']) .navigation.secondary-menu a.is-active:after {
  background-color:var(--primary-blue-light-3);
}
:host([site='GHS']):host([is-top-bar-menu]) .navigation nav > ul > li.tel {
  display:block;
}
:host([site='GHS']):host([is-top-bar-menu]) .navigation nav > ul > li.tel ghs-phone-contact {
  min-height:3.5rem;
}
:host([site='GHS']):host([is-top-bar-menu]) .navigation nav > ul > li.tel ghs-phone-contact {
  padding-top:0px;
  padding-bottom:0px;
}
:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
  font-family:var(--ff-body);
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    display:flex;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    flex-direction:row;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    justify-content:flex-end;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    gap:1.75rem;
  }
}
:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-top-width:1px;
}
:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-bottom-width:0px;
}
:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-style:solid;
}
:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-color:var(--neutral-gray-4);
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
    border-top-width:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > a, :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > ghs-phone-contact {
    min-height:3.5rem;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > a, :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > ghs-phone-contact {
    min-height:fit-content;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > a, :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > ghs-phone-contact {
    padding-top:0px;
    padding-bottom:0px;
  }
}
:host([site='GHS']):host([is-subnav]) nav > ul > li {
  text-transform:none;
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) nav > ul > li > a:after {
    background-color:var(--primary-blue-light-3);
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant {
  background-color:var(--primary-blue-light-2);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant {
  color:var(--neutral-white);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant [cloned-slot-name='subnav-label'] {
  display:block;
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant [cloned-slot-name='subnav-label'] {
    display:none;
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant [cloned-slot-name='subnav-label'] button.dropdown-trigger.open ghs-icon{
            transform:rotate(180deg);
          }
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
  margin-left:auto;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
  margin-right:auto;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
  display:none;
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    display:block;
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1024px;
  }
}
@media (min-width: 1280px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1280px;
  }
}
@media (min-width: 1360px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1360px;
  }
}
@media (min-width: 2180px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1360px;
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav.hide {
  display:block;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  width:100%;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  justify-content:space-between;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  padding-left:1rem;
  padding-right:1rem;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  color:var(--neutral-white);
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
    display:none;
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-width:0px;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-bottom-width:1px;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-style:solid;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-color:var(--neutral-white);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger ghs-icon {
  border-color:var(--neutral-white);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger ghs-icon {
  color:var(--neutral-white);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger:hover {
  cursor:pointer;
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger:hover {
    background-color:var(--neutral-white);
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul {
  justify-content:flex-start;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul {
  gap:0.5rem;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li button.dropdown-trigger {
  padding-left:1rem;
  padding-right:1rem;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li button.dropdown-trigger {
  color:var(--neutral-white);
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li button.dropdown-trigger:hover {
    color:var(--primary-blue-dark);
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a + button.dropdown-trigger {
  margin-left:-1rem;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a + button.dropdown-trigger {
  padding-left:0px;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover {
  cursor:pointer;
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover {
    background-color:var(--neutral-white);
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover a {
    color:var(--primary-blue-dark);
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover ghs-icon {
    color:var(--primary-blue-dark);
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a {
  padding-left:1rem;
  padding-right:1rem;
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a {
  color:var(--neutral-white);
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a:after {
    background-color:var(--primary-blue);
  }
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li ghs-icon {
  border-color:var(--neutral-white);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li ghs-icon {
  color:var(--neutral-white);
}
:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li > ul li:first-child {
  border-color:var(--primary-blue);
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li > ul a {
    color:var(--primary-blue-dark);
  }
}
@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) nav > ul > li > ul > li:first-child {
    border-color:var(--primary-blue-light-3);
  }
}
:host([site='GHS']):host([is-subnav]) button.dropdown-trigger {
  text-transform:none;
}
:host([site='BH']) nav .button, :host([site='BH']) nav button {
  font-family:var(--bh-ff-body);
}
@media (min-width: 1024px) {
  :host([site='BH']) nav .button, :host([site='BH']) nav button {
    color:var(--bh-neutral-default);
  }
}
:host([site='BH']) .navigation {
  background-color:var(--bh-neutral-white);
}
:host([site='BH']) .navigation {
  font-weight:var(--fw-bold);
}
@media (min-width: 1024px){
:host([site='BH']) .navigation{
      box-shadow:none
  }
    }
:host([site='BH']) .navigation nav > ul {
  font-family:var(--bh-ff-body);
}
:host([site='BH']) .navigation nav > ul {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}
:host([site='BH']) .navigation nav > ul {
  font-weight:var(--fw-bold);
}
:host([site='BH']) .navigation nav > ul {
  color:var(--bh-brand-primary-default);
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul {
    gap:0px;
  }
}
@media (min-width: 1360px) {
  :host([site='BH']) .navigation nav > ul {
    gap:2rem;
  }
}
:host([site='BH']) .navigation nav > ul > li {
  display:flex;
}
:host([site='BH']) .navigation nav > ul > li {
  min-height:4rem;
}
:host([site='BH']) .navigation nav > ul > li {
  flex-direction:row;
}
:host([site='BH']) .navigation nav > ul > li {
  justify-content:space-between;
}
:host([site='BH']) .navigation nav > ul > li {
  border-color:var(--bh-neutral-default);
}
:host([site='BH']) .navigation nav > ul > li {
  padding-left:1rem;
  padding-right:1rem;
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    justify-content:flex-start;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-width:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-top-width:4px;
    border-bottom-width:4px;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-style:solid;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-color:var(--outline-transparent);
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    padding-left:0.625rem;
    padding-right:0.625rem;
  }
}
:host([site='BH']) .navigation nav > ul > li:hover, :host([site='BH']) .navigation nav > ul > li[is-dropdown-open] {
  background-color:var(--bh-brand-primary-lightest);
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li:hover, :host([site='BH']) .navigation nav > ul > li[is-dropdown-open] {
    border-top-color:var(--bh-brand-primary-default);
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li:hover, :host([site='BH']) .navigation nav > ul > li[is-dropdown-open] {
    border-bottom-color:var(--bh-brand-primary-lightest);
  }
}
:host([site='BH']) .navigation nav > ul > li > a {
  min-height:4rem;
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > a {
    min-height:0px;
  }
}
:host([site='BH']) .navigation nav > ul > li > ul {
  background-color:var(--bh-brand-primary-lightest);
}
:host([site='BH']) .navigation nav > ul > li > ul {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}
:host([site='BH']) .navigation nav > ul > li > ul {
  color:var(--bh-brand-primary-default);
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > ul {
    margin-left:-0.625rem;
  }
}
@media (min-width: 1024px){
:host([site='BH']) .navigation nav > ul > li > ul{
        top:100%
    }
      }
:host([site='BH']) .navigation nav > ul > li > ul > li {
  padding-bottom:2rem;
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > ul > li {
    padding-bottom:1.25rem;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > ul > li:first-child {
    padding-top:1.25rem;
  }
}
:host([site='BH']) .navigation nav > ul > li > ul > li > a {
  display:block;
}
:host([site='BH']) .navigation nav > ul > li > ul > li > a {
  font-weight:var(--fw-normal);
}
:host([site='BH']) .navigation nav > ul > li > ul > li > a:hover, :host([site='BH']) .navigation nav > ul > li > ul > li > a.is-active {
  text-decoration-line:underline;
}
:host([site='BH']) .navigation button.dropdown-trigger {
  display:flex;
}
:host([site='BH']) .navigation button.dropdown-trigger {
  min-height:4rem;
}
:host([site='BH']) .navigation button.dropdown-trigger {
  justify-content:space-between;
}
:host([site='BH']) .navigation button.dropdown-trigger {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}
:host([site='BH']) .navigation button.dropdown-trigger {
  font-weight:var(--fw-bold);
}
:host([site='BH']) .navigation button.dropdown-trigger {
  color:var(--bh-brand-primary-default);
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    height:100%;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    min-height:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    width:auto;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    justify-content:flex-start;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    padding-top:0px;
    padding-bottom:0px;
  }
}
:host([site='BH']) .navigation button.dropdown-trigger.no-link {
  width:100%;
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger.no-link {
    width:auto;
  }
}
:host([site='BH']) .navigation button.dropdown-trigger:hover, :host([site='BH']) .navigation a:hover, :host([site='BH']) .navigation a.is-active {
  color:var(--bh-brand-primary-dark);
}
:host([site='BH']) .navigation button.dropdown-trigger:hover ghs-icon, :host([site='BH']) .navigation a:hover ghs-icon, :host([site='BH']) .navigation a.is-active ghs-icon {
  color:var(--bh-neutral-darker);
}
:host([site='BH']) .navigation button.dropdown-trigger[aria-expanded='true'] {
  margin-bottom:1rem;
}
@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger[aria-expanded='true'] {
    margin-bottom:0px;
  }
}
:host([site='BH']) .navigation.secondary-menu {
  background-color:var(--bh-brand-primary-darker);
}
:host([site='BH']) .navigation.secondary-menu a {
  color:var(--bh-neutral-white);
}
:host([site='BH']) .navigation.secondary-menu a:hover:before {
  background-color:var(--bh-neutral-white);
}
:host([site='BH']) .navigation.secondary-menu a.is-active:before {
  background-color:var(--bh-brand-primary-light);
}
:host([site='BH']):host([is-top-bar-menu]) .navigation {
  background-color:var(--neutral-transparent);
}
:host([site='BH']):host([is-top-bar-menu]) .navigation nav > ul > li {
  min-height:0px;
}
:host([site='BH']):host([is-top-bar-menu]) .navigation nav > ul > li {
  background-color:var(--neutral-transparent);
}
:host([site='BH']):host([is-top-bar-menu]) .navigation nav > ul > li {
  padding-left:0px;
  padding-right:0px;
}
:host([site='BH']):host([is-utility-menu]) .navigation {
  border-width:0px;
}
:host([site='BH']):host([is-utility-menu]) .navigation {
  border-top-width:1px;
}
:host([site='BH']):host([is-utility-menu]) .navigation {
  border-bottom-width:1px;
}
:host([site='BH']):host([is-utility-menu]) .navigation {
  border-style:solid;
}
:host([site='BH']):host([is-utility-menu]) .navigation {
  border-color:var(--bh-neutral-default);
}
:host([site='BH']):host([is-utility-menu]) .navigation {
  background-color:var(--bh-neutral-lighter);
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation {
    border-style:none;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation {
    background-color:var(--neutral-transparent);
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation {
    padding:0px;
  }
}
:host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-family:var(--bh-ff-body);
}
:host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
    justify-content:space-between;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
    gap:1rem;
  }
}
:host([site='BH']):host([is-utility-menu]) .navigation nav > ul > li {
  align-items:flex-start;
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul > li {
    align-items:center;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul > li {
    border-width:0px;
  }
}
:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger, :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}
:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger, :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-weight:var(--fw-normal);
}
:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger, :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  color:var(--bh-neutral-black);
}
:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger:hover, :host([site='BH']):host([is-utility-menu]) .navigation a:hover, :host([site='BH']):host([is-utility-menu]) .navigation a.is-active {
  color:var(--bh-brand-primary-dark);
}
:host([site='BH']):host([is-utility-menu]) button.dropdown-trigger:hover, :host([site='BH']):host([is-utility-menu]) a:hover, :host([site='BH']):host([is-utility-menu]) a.is-active {
  color:var(--bh-brand-primary-dark);
}
:host([site='BH']):host([is-utility-menu]) button.dropdown-trigger:hover ghs-icon, :host([site='BH']):host([is-utility-menu]) a:hover ghs-icon, :host([site='BH']):host([is-utility-menu]) a.is-active ghs-icon {
  color:var(--bh-neutral-darker);
}
:host([site='BH']):host([is-subnav]) nav > ul {
  z-index:50;
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-subnav]) nav > ul > li > a:after {
    background-color:var(--bh-brand-primary-light);
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([is-subnav]) nav > ul > li > ul > li:first-child {
    border-color:var(--bh-brand-primary-light);
  }
}
`;